import React from 'react'
import { Button, Grid, InputAdornment, TextField, Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import * as yup from 'yup'
import colors from '../../../colors';
import { useFormik } from 'formik';
import { ReactComponent as IconClose } from '../../../../icons/closeButton.svg';
import { selectGlobalDataState } from '../../../../features/global/globalDataSlice';
import { sendGeneralRequest } from '../../../../features/generalRequest';
import { selectForgotPasswordState, setIsPasswordSuccessfullyChanged } from '../../../../features/resetPassword/forgotPasswordSlice';
import { useNavigate, useLocation } from "react-router-dom";
import { setGeneralMessage, setToken } from '../../../../features/global/globalDataSlice';
import Lottie from "lottie-react";
import smallLoadingAnimation from '../../../../icons/lottieAnimations/smallLoading.json'
import RegistrationPasswordTextValidator from '../../../general/RegistrationPasswordTextValidator'
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { texts } from '../../../general/texts';

const validationSchema = yup.object({
    password: yup
        .string()
        .required(texts["message-invalid-change-password"])
        .matches(
            /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,}$/,
            ' '
        ),
    newpassword: yup
        .string()
        .required(texts["message-invalid-change-password"])
        .matches(
            /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,}$/,
            ' '
        ),
})

const ForgotPassword = ({ onBackButtonClick }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const globalDataSliceState = useSelector(selectGlobalDataState)
    const forgotPasswordSliceState = useSelector(selectForgotPasswordState)

    const formik = useFormik({
        initialValues: {
            token: globalDataSliceState.token,
            password: '',
            newpassword: ''
        },
        validationSchema: validationSchema,
        onSubmit: values => {
            dispatch(sendGeneralRequest({ request: values, baseUrlKey: 'auth', endpoint: 'ChangePassword' }))
        }
    })

    const [showPassword, setShowPassword] = React.useState(false);
    const [showNewPassword, setShowNewPassword] = React.useState(false);


    React.useEffect(() => {
        if (forgotPasswordSliceState.isPasswordSuccessfullyChanged) {
            dispatch(setGeneralMessage({ type: forgotPasswordSliceState.success === true ? 'success' : 'error', message: forgotPasswordSliceState.message }))
            dispatch(setToken(forgotPasswordSliceState.token))
            dispatch(setIsPasswordSuccessfullyChanged(false))
        }
    }, [forgotPasswordSliceState.isPasswordSuccessfullyChanged])

    return (
        <form>
            <Grid container justifyContent='center' width={'100%'} rowSpacing={8}>
                <Grid container item md={6} xs={10} mt={1} justifyContent={'right'} >
                    <Button sx={{ borderRadius: '20px', ":hover": { backgroundColor: colors.lightOrange } }} onClick={onBackButtonClick}><IconClose /></Button>
                </Grid>
                <Grid item md={12} xs={12} marginBottom={2}>
                    <Typography sx={{ fontFamily: 'GerberaBold', color: colors.darkBlue, fontSize: '2rem' }} >{texts["title-change-password"]}</Typography>
                </Grid>
                <Grid container item md={12} sm={12} xs={12} direction="row" justifyContent="center" alignItems="flex-start" columnGap={2} pl={{md:0,sm:20, xs:10}}>
                    <Grid container item md={4} sm={12} xs={12} flexDirection='column'>
                        <Grid container item justifyContent='flex-start' mb={2}>
                            <Typography sx={{ color: colors.orange, fontSize: '1.2rem', fontFamily: 'GerberaMedium' }} >{texts["placeholder-old-password"]}</Typography>
                        </Grid>
                        <Grid container item justifyContent='flex-start' mb={2}>
                            <TextField id="password" name="password" autoComplete="off" onChange={formik.handleChange} value={formik.values.password} error={formik.touched.password && Boolean(formik.errors.password)} helperText={formik.touched.password && formik.errors.password} color="warning" type={showPassword ? "text" : "password"} variant="standard" InputProps={{ endAdornment: <InputAdornment position="end"><Button disableRipple={true} onClick={() => setShowPassword(s => !s)} sx={{ background: colors.white, color: colors.darkBlue, borderRadius: '100%', height: '5px', ':hover': { background: colors.white } }} >{showPassword === false && <VisibilityIcon />}{showPassword === true && <VisibilityOffIcon />}</Button></InputAdornment> }} sx={{ width: '15vw', '@media (max-width: 899px)': { width: '50vw' } }} />
                        </Grid>
                    </Grid>
                    <Grid container item md={4} sm={12} xs={12} flexDirection='column'>
                        <Grid container item justifyContent='flex-start' mb={2}>
                            <Typography sx={{ color: colors.orange, fontSize: '1.2rem', fontFamily: 'GerberaMedium' }} >{texts["placeholder-new-password"]}</Typography>
                        </Grid>
                        <Grid container item justifyContent='flex-start' mb={2}>
                            <TextField id="newpassword" name="newpassword" autoComplete="off" onChange={formik.handleChange} value={formik.values.newpassword} error={formik.touched.newpassword && Boolean(formik.errors.newpassword)} helperText={formik.touched.newpassword && formik.errors.newpassword} color="warning" type={showNewPassword ? "text" : "password"} variant="standard" InputProps={{ endAdornment: <InputAdornment position="end"><Button disableRipple={true} onClick={() => setShowNewPassword(s => !s)} sx={{ background: colors.white, height: '5px', color: colors.darkBlue, borderRadius: '100%', ':hover': { background: colors.white } }} >{showNewPassword === false && <VisibilityIcon />}{showNewPassword === true && <VisibilityOffIcon />}</Button></InputAdornment> }} sx={{ width: '15vw', '@media (max-width: 899px)': { width: '50vw' } }} />
                        </Grid>
                        <Grid container item justifyContent='flex-start' mb={1}>
                            <RegistrationPasswordTextValidator password={formik.values.newpassword} />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item md={12} xs={12} mt={{sm:5, xs:5}}>
                    <Button disabled={forgotPasswordSliceState.isLoading ? true : false} onClick={formik.handleSubmit} sx={{ background: colors.gradientOrange, color: colors.white, width: '12%', fontSize: '1rem', fontFamily: 'GerberaBold', textTransform: 'none', '@media (max-width: 899px)': { width: '30%', mb: 10, mt: '-25%' } }}>{texts["button-continue"]}</Button>
                </Grid>
                <Grid container justifyContent={'center'} >
                    <Grid container item md={1} xs={1} >
                        {forgotPasswordSliceState.isLoading && <Lottie animationData={smallLoadingAnimation} loop={true} autoplay={true} />}
                    </Grid>
                </Grid>
            </Grid>
        </form>
    )
}
export default ForgotPassword